import { routerReducer } from 'react-router-redux';

import tabbarSlice from '../components/Tabbar/tabbarSlice';
import selectTableSlice from '../components/SelectTable/selectTableSlice';
import filterbarSlice from '../components/Filterbar/filterbarSlice';
import chartsSelectSlice from '../components/Charts/ChartsSelect/ChartsSelectSlice';
import userSlice from './slices/userSlice';
import designListSlice from './slices/designListSlice';
import selectedDesignSlice from './slices/selectedDesignSlice';

const rootReducer = {
	/* UI/App layer */
	routing: routerReducer,
	tabbar: tabbarSlice.reducer,
	selectTable: selectTableSlice.reducer,
	filterbar: filterbarSlice.reducer,
	chartsSelect: chartsSelectSlice.reducer,

	/* Data layer */
	user: userSlice.reducer,
	designList: designListSlice.reducer,
	selectedDesign: selectedDesignSlice.reducer
};

export default rootReducer;
